// the UI displays units but the API uses milliunits
export function userInsulinToServerInsulin(units: number) {
  return Math.round(units * 1000)
}
